<template>
  <div class="information">
    <div class="info-top">
      <div class="mess-con">
        <div class="mess-text">
          <div class="top-mess">{{governance.GovernanceCooperation}}</div>
          <!-- <div class="top-message">{{governance.GovernanceCooperationTxt}}</div> -->
        </div>
      </div>
      <!-- <img src="@/assets/my/head.jpg" alt="">
      <div class="top-mess">{{governance.GovernanceCooperation}}</div>
      <div class="top-message">{{governance.GovernanceCooperationTxt}}</div> -->
    </div>
    <div class="info-bot">
      <div class="body-cont" id="governZcfg">
        <div class="bot-line"></div>
        <div class="bot-tit" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">{{governance.PoliciesAndRegulations}}
          <span class="en-text">
            Legales and regulations
          </span>
        </div>
        <div class="bot-all">
          <div class="items" v-for="(item, index) in zcfgData" :key="index" @click="goDetail(item, 'policy')">
            <div class="item">
              <div class="item-left">{{ $i18n.locale=='zh' ? item.news_date : formatDate(item.news_date) }}</div>
              <div class="item-right">
                <div class="titles">
                  {{ $i18n.locale=='zh' ? item.title : item.english_title }}
                </div>
                <div class="context">
                  {{ $i18n.locale=='zh' ? item.content : item.english_content }}
                </div>
              </div>
            </div>
            <div class="line"></div>
          </div>
          <div class="pagination">
            <div class="page-text">{{governance.Total}} {{ zcfgPage.total }} {{governance.items}}</div>
            <el-pagination
              background
              :pager-count="5"
              :page-size="zcfgPage.size"
              :page-count="zcfgPage.count"
              layout="prev, pager, next"
              :total="zcfgPage.total"
              @current-change="(value) => zcfgCurrentChange(value,'governZcfg')"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="wide-bg" id="governYjbg">
        <div class="body-cont">
          <div class="bot-line"></div>
          <div class="bot-tit" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">{{governance.ResearchReport}}
            <span class="en-text">
              Research report
            </span>
          </div>
          <div class="type-box">
            <div
              class="tab"
              :class="tabName == '白皮书' ? 'active' : ''"
              @click="tabChange('白皮书')"
            >
            {{governance.ResearchReport}}
            </div>
            <div class="cut">|</div>
            <!-- <div
              class="tab"
              :class="tabName == '白皮书' ? 'active' : ''"
              @click="tabChange('白皮书')"
            >
            {{governance.whitepaper}}
            </div>
            <div class="cut">|</div>
            <div
              class="tab"
              :class="tabName == '蓝皮书' ? 'active' : ''"
              @click="tabChange('蓝皮书')"
            >
            {{governance.BlueBook}}
            </div>
            <div class="cut">|</div> -->
            <div
              class="tab"
              :class="tabName == '金砖中心ICT文件' ? 'active' : ''"
              @click="tabChange('金砖中心ICT文件')"
            >
            {{governance.BRICSCenterICTDocuments}}
            </div>
          </div>
          <div v-if="tabName == '金砖中心ICT文件'">
            <div class="file-box">
              <div
                class="file-items"
                v-for="(item, index) in jzwjData"
                :key="index"
                @click="jzwjHttp(item)"
              >
                <div>{{ $i18n.locale=='zh' ? item.title : item.english_title }}</div>
                <div class="time">{{ $i18n.locale=='zh' ? item.data_date : formatDate(item.data_date) }}</div>
              </div>
            </div>
            <div class="pagination">
              <div class="page-text">{{governance.Total}} {{ jzwjPage.total }} {{governance.cases}}</div>
              <el-pagination
                v-if="tabName == '金砖中心ICT文件'"
                key="jzwj"
                background
                :pager-count="5"
                :page-size="jzwjPage.size"
                :page-count="jzwjPage.count"
                layout="prev, pager, next"
                :total="jzwjPage.total"
                @current-change="(value) => jzwjCurrentChange(value,'governYjbg')"
              >
              </el-pagination>
            </div>
          </div>
          <div v-else-if="tabName == '白皮书'">
            <div class="cont-list">
              <div
                class="items"
                v-for="(item, index) in bpsData"
                :key="index"
                @click="jzwjHttp(item)"
              >
                <img :src="item.picture" alt="" />
                <!-- <div class="title-box">
                  {{ item.title }}
                </div> -->
              </div>
            </div>
            <div class="pagination">
              <div class="page-text">{{governance.Total}} {{ bpsPage.total }} {{governance.cases}}</div>
              <el-pagination
                v-if="tabName == '白皮书'"
                key="bps"
                background
                :pager-count="5"
                :page-size="bpsPage.size"
                :page-count="bpsPage.count"
                layout="prev, pager, next"
                :total="bpsPage.total"
                @current-change="(value) => bpsCurrentChange(value,'governYjbg')"
              >
              </el-pagination>
            </div>
          </div>
          <div v-else>
            <div class="cont-list">
              <div
                class="items"
                v-for="(item, index) in lpsData"
                :key="index"
                @click="jzwjHttp(item)"
              >
                <img :src="item.picture" alt="" />
              </div>
            </div>
            <div class="pagination">
              <div class="page-text">{{governance.Total}} {{ lpsPage.total }} {{governance.cases}}</div>
              <el-pagination
                v-if="tabName == '蓝皮书'"
                key="lps"
                :pager-count="5"
                background
                :page-size="lpsPage.size"
                :page-count="lpsPage.count"
                layout="prev, pager, next"
                :total="lpsPage.total"
                @current-change="(value) => lpsCurrentChange(value,'governYjbg')"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="gjzl" id="governGjzl">
        <div class="body-cont">
          <div class="bot-line"></div>
          <div class="bot-tit" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">{{governance.InternationalGovernance}}
            <span class="en-text">
              International governance
            </span>
          </div>
          <div class="cont-list">
            <div
              class="items"
              v-for="(item, index) in gjzlData"
              :key="index"
              @click="jzwjHttp(item)"
            >
              <img :src="item.picture" alt="" />
              <div class="title-box">
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="pagination">
            <div class="page-text">{{governance.Total}} {{ gjzlPage.total }} {{governance.cases}}</div>
            <el-pagination
              background
              :pager-count="5"
              :page-size="gjzlPage.size"
              :page-count="gjzlPage.count"
              layout="prev, pager, next"
              :total="gjzlPage.total"
              @current-change="(value) => gjzlCurrentChange(value,'governGjzl')"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="gjbz" id="governGjbz">
        <div class="mess-con mess-special">
          <div class="mess-text">
            <div class="top-mess">{{governance.InternationalStandards}}
            </div>
            <div class="top-message">International Standard</div>
            <div class="enter-btn" @click="gjbzUrl()">
              {{governance.Enternow}}
              <img src="../../assets/img/enter.png" alt="" />
            </div>
          </div>
        </div>
        <!-- <div class="top-mess">{{governance.InternationalStandards}}
        </div>
        <div class="top-message">International Standard</div>
        <div class="enter-btn" @click="gjbzUrl()">
          {{governance.Enternow}}
          <img src="../../assets/img/enter.png" alt="" />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import zcfg from '../../../public/json/治理合作-政策法规.json'
import jzwj from '../../../public/json/治理合作-资料报告.json'
import gjzl from '../../../public/json/治理合作-国际治理.json'
export default {
  data() {
    return {
      formInline: {
        time: "",
        country: "",
        keyword: "",
      },
      tabName: '白皮书',
      zcfgData: [],
      zcfgPage: {
        count: 1,
        size: 5,
        total: 20,
      },
      jzwjPage: {
        count: 1,
        size: 5,
        total: 20,
      },
      jzwjData: [],
      jzwjAllList: [],
      bpsAllList:[],
      lpsAllList: [],
      bpsPage: {
        count: 1,
        size: 8,
        total: 20,
      },
      bpsData: [],
      lpsPage: {
        count: 1,
        size: 8,
        total: 20,
      },
      lpsData: [],
      gjzlData:[],
      gjzlPage: {
        count: 1,
        size: 8,
        total: 20,
      },
      sectionId:'',
    };
  },
  watch:{
    // sectionId(newId,oldval){
    //   console.log(newId,'---newId',oldval)
    //   this.sectionId = newId;
    //   this.$nextTick(() => {
    //     this.scrollTo(this.sectionId);
    //   });
    // }
  },
  computed:{
    governance(){
      return this.$t('governance')
    }
  },
  created(){
    this.initializeEventListener();
  },
  mounted() {
    this.jzwjAllList = jzwj.RECORDS.filter( (item) => item.type == '金砖中心ICT文件');
    this.bpsAllList = (jzwj.RECORDS.filter( (item) => item.type == '白皮书')).concat(jzwj.RECORDS.filter( (item) => item.type == '蓝皮书'))
    // this.bpsAllList = jzwj.RECORDS.filter( (item) => item.type == '白皮书');
    this.lpsAllList = jzwj.RECORDS.filter( (item) => item.type == '蓝皮书');
    this.getZcfgData();
    // this.getJzwjData();
    this.getBpsData()
    this.getGjzlData();
  
  },
  methods: {
    initializeEventListener() {
      let that = this;
      this.$bus.$off("changePont");
      this.$bus.$on("changePont", (sectionId) => {
        this.sectionId = sectionId.isPont;
          this.$nextTick(() => {
            that.scrollTo(this.sectionId);
          });
      });
    },
    scrollTo(sectionId) {
      this.$nextTick(()=>{
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      })
    },
    tabChange(name) {
      this.tabName = name;
      this.jzwjPage.count = 1;
      this.bpsPage.count = 1;
      this.lpsPage.count = 1;
      console.log( this.jzwjPage.count, this.bpsPage.count);
      this.$forceUpdate();
      if(name == '金砖中心ICT文件') {
        this.getJzwjData();
      } else if( name == '白皮书') {
        this.getBpsData();
      } else {
        this.getLpsData();
      }
    },
    zcfgCurrentChange(val,id) {
      this.sectionId = id;
      this.zcfgPage.count = val;
      this.getZcfgData();
      this.scrollTo(this.sectionId);
    },
    getZcfgData() {
      this.zcfgPage.total = zcfg.RECORDS.length;
      this.zcfgData = [];
      zcfg.RECORDS.forEach( (item,index) => {
        if(index >= this.zcfgPage.size * (this.zcfgPage.count - 1 )&& index < this.zcfgPage.size *  this.zcfgPage.count){
          this.zcfgData.push(item);
        }
      })
    },
    jzwjCurrentChange(val, id) {
      this.jzwjPage.count = val;
      this.getJzwjData();
      this.sectionId = id;
      this.scrollTo(this.sectionId);
    },
    getJzwjData() {
      this.jzwjPage.total = this.jzwjAllList.length;
      this.jzwjData = [];
      this.jzwjAllList.forEach( (item,index) => {
        if(index >= this.jzwjPage.size * (this.jzwjPage.count - 1 )&& index < this.jzwjPage.size *  this.jzwjPage.count){
          this.jzwjData.push(item);
        }
      })
    },
    jzwjHttp(item) {
      if(item.url) {
        window.open(item.url);
      }
    },
    bpsCurrentChange(val, id) {
      this.bpsPage.count = val;
      this.getBpsData();
      this.sectionId = id;
      this.scrollTo(this.sectionId);
    },
    getBpsData() {
      this.bpsPage.total = this.bpsAllList.length;
      this.bpsData = [];
      this.bpsAllList.forEach( (item,index) => {
        if(index >= this.bpsPage.size * (this.bpsPage.count - 1 )&& index < this.bpsPage.size *  this.bpsPage.count){
          this.bpsData.push(item);
        }
      })
    },
    lpsCurrentChange(val, id) {
      this.lpsPage.count = val;
      this.getLpsData();
      this.sectionId = id;
      this.scrollTo(this.sectionId);
    },
    getLpsData() {
      this.lpsPage.total = this.lpsAllList.length;
      this.lpsData = [];
      this.lpsAllList.forEach( (item,index) => {
        if(index >= this.lpsPage.size * (this.lpsPage.count - 1 )&& index < this.lpsPage.size *  this.lpsPage.count){
          this.lpsData.push(item);
        }
      })
    },
    gjzlCurrentChange(val, id) {
      this.gjzlPage.count = val;
      this.getGjzlData();
      this.sectionId = id;
      this.scrollTo(this.sectionId);
    },
    getGjzlData() {
      this.gjzlPage.total = gjzl.RECORDS.length;
      this.gjzlData = [];
      gjzl.RECORDS.forEach( (item,index) => {
        if(index >= this.gjzlPage.size * (this.gjzlPage.count - 1 )&& index < this.gjzlPage.size *  this.gjzlPage.count){
          this.gjzlData.push(item);
        }
      })
    },
    gjbzUrl() {
      window.open('https://www.itu.int/rec/T-REC/en');
    },
    goDetail(item, type) {
      const query = {
        id: item.id,
        type: type,
        tit1:'治理合作',
        tit2:'人工智能国际治理相关法规'
      }
      this.$router.push({ path: '/InfoDetail', query })
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error('Invalid date format');
        return null;
      }
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.bot-tit-en {
  font-weight: 600 !important;
}
.information {
  width: 100%;
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
  .info-bot {
    .body-cont {
      max-width: 1200px;
      margin: 0 auto;
      padding-top: 60px;
      box-sizing: border-box;
      padding-bottom: 20px;
    }
    .bot-line {
      margin: 0 auto;
      width: 84px;
      height: 4px;
      background: linear-gradient(270deg, #1d3e95 0%, #4840c2 100%);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
    }
    .bot-tit {
      margin: 0 auto;
      margin-top: 22px;
      height: 40px;
      font-family: Inter;
      font-weight: 400;
      font-size: 36px;
      color: #080808;
      line-height: 40px;
      position: relative;
      .en-text {
        height: 50px;
        font-family: Inter;
        font-weight: 700;
        font-size: 36px;
        color: rgba(194, 194, 194, 0.12);
        line-height: 50px;
        text-align: center;
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translate(-50%, 0);
        white-space: nowrap;
      }
    }
    .bot-input {
      margin-top: 57px;
      text-align: right;
    }
    .bot-all {
      margin-top: 50px;
      // padding: 0 2vw;
      box-sizing: border-box;
      .items {
        .item {
          display: flex;
          font-family: Inter;
          .item-left {
            white-space: nowrap;
            height: 45px;
            font-family: D-DIN, D-DIN;
            font-weight: 400;
            font-size: 18px;
            color: #3d3d3d;
            line-height: 45px;
            margin-right: 38px;
          }
          .item-right {
            .titles {
              font-weight: 500;
              font-size: 18px;
              color: #333640;
              line-height: 45px;
              text-align: left;
            }
            .context {
              font-size: 16px;
              color: #666666;
              line-height: 40px;
              text-align: left;
              display: -webkit-box;
              -webkit-line-clamp: 2; //显示最大行数
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
        .item:hover {
          .item-left {
            color: #1b3e92;
            cursor: pointer;
          }
          .titles {
            color: #1b3e92;
            cursor: pointer;
          }
          .context {
            color: #1b3e92;
            cursor: pointer;
          }
        }
        .line {
          height: 1px;
          background: #d8d8d8;
          margin: 40px 0px;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .page-text {
      font-size: 14px;
      color: #666666;
    }
  }
  .wide-bg {
    width: 100%;
    // background: #f5f7fa;

    .type-box {
      display: flex;
      align-items: center;
      color: #333640;
      height: 50px;
      cursor: pointer;
      margin: 40px 0px 30px 0px;
      > div {
        margin: 0px 18px;
        height: 100%;
        display: flex;
        align-items: center;
      }
      .active {
        border-bottom: 1px #1b3e92 solid;
        color: #1b3e92;
      }
      .tab {
        font-size: 20px;
        font-weight: 600;
      }
      .cut {
        color: #cccccc;
      }
      .tab:first-child {
        margin-left: 0px;
      }
    }
  }
  .file-box {
    margin-bottom: 40px;
    // padding: 0 2vw;
    box-sizing: border-box;
    .file-items {
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #d8d8d8;
      box-sizing: border-box;
      cursor: pointer;
      .time {
        font-size: 14px;
        color: #61656c;
        font-weight: 400;
      }
    }
  }
  .cont-list {
    display: flex;
    flex-wrap: wrap;
    .items {
      width: calc(25% - 18px);
      height: auto;
      margin-right: 24px;
      box-shadow: 0px 4px 20px 5px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-bottom: 40px;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0px;
      }
      img {
        width: 100%;
        height: auto;
      }
      .title-box {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        border-top: 1px solid #d8d8d8;
        box-sizing: border-box;
        font-size: 14px;
        color: #000;
        font-weight: 500;
        padding: 0px 5px;
        box-sizing: border-box;
      }
    }
  }
  .gjzl {
    .cont-list {
      margin-top: 50px;
    }
  }
  .gjbz {
    height: 315px;
    // background: url(../../assets/img/gjbz.png) no-repeat;
    // background-size: 100% 100%;
    position: relative;
    color: #fff;
    .mess-con {
      height: 290px;
      max-width: 1200px;
      background: url(../../assets/img/gjbz.png) no-repeat;
      background-size: 100% 100%;
      position: relative;
      // background: #F5F7FA !important;
      margin: 0 auto;
      .mess-text {
        // max-width: 1200px;
        // width: 100%;
        margin: 0 auto;
        text-align: left;
        padding: 100px 0 0 0;
        // position: absolute;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 75px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 35px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .enter-btn {
      width: 192px;
      height: 64px;
      background: #3a86e3;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      font-size: 18px;
      position: absolute;
      right: 2vw;
      top: 50%;
      transform: translateY(-50%);
      img {
        width: 16px;
        height: 16px;
        margin-left: 20px;
      }
    }
  }
}

::v-deep .el-form-item {
  margin-bottom: 0px;
}
::v-deep .el-form-item__content {
  line-height: 52px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1b3e92;
  color: #fff;
}
@media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .page-text {
    width: 100px !important;
  }
  .content-photo {
    display: none !important;
  }
  .tab {
    font-size: 14px !important;
  }
  .file-items {
    display: inherit !important;
    height: 58px !important;
    &>div {
      font-size: 16px !important;
      font-weight: 400 !important;
      text-align: left !important;
      margin-top: 10px !important;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &>.time {
      text-align: right !important;
      margin-top: 6px;
      font-size: 14px !important;
    }
  }
  .time {
    min-width: 100px;
  }
  .title-box {
    display: -webkit-box !important;
    height: auto !important;
    -webkit-line-clamp: 3; //显示最大行数
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .bot-all {
    padding: 0 20px;
    box-sizing: border-box;
    .item-left {
      display: none !important;
    }
  }
  .en-text {
    font-size: 30px !important;
  }
  .file-box {
    padding: 0 20px !important;
    box-sizing: border-box;
    width: 100%;
  }
  .enter-btn {
    // left: 4vw;
    left: 2vw !important;
    top: 160px !important;
    width: 150px !important;
    height: 50px !important;
  }
  .pagination {
    flex-direction: column;
    align-items: flex-end !important;
    .page-text {
      margin-bottom: 10px;
    }
  }
  .type-box {
    padding-left: 10px;
    box-sizing: border-box;
    .cut {
      margin: 0px 4px !important;
    }
  }
  .gjbz {
    .top-mess {
      left: 15% !important;
      font-size: 28px !important;
      line-height: 56px !important;
    }
    .top-message {
      left: 15% !important;
      box-sizing: border-box;
      font-size: 16px !important;
    }
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
  .gjbz {
    height: 220px !important;
  }
  .mess-special {
    height: 220px !important;
    .mess-text {
      padding: 20px 0 0 0 !important;
      .top-message {
        margin-top: 0px !important;
      }
    }
  }
  .cont-list {
    padding: 0 2vw !important;
    .items {
      width: calc(25% - 8px) !important;
      margin-right: 8px !important;
      .title-box {
        display: none !important;
      }
    }
  }
}
</style>
